"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const analytics_1 = require("@completeanatomy/analytics");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const hooks_1 = require("../../hooks");
const react_1 = __importDefault(require("react"));
function DescriptionButton(props, ref) {
    const screenInfo = (0, hooks_1.useScreenInfo)();
    const { onClick, tooltipPlace, disabled = false, isSelected = false } = props;
    const analytics = (0, analytics_1.useAnalytics)();
    const { t } = (0, i18n_1.useTranslation)();
    const onHandleClick = () => {
        analytics.log('screen_description_opened');
        onClick();
    };
    if (!screenInfo.information) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(TooltipButton, { tooltip: {
            context: t(i18n_1.Strings.toolbar.screenDescription),
            place: tooltipPlace,
        }, ref: ref, onClick: onHandleClick, disabled: disabled, isSelected: isSelected, children: (0, jsx_runtime_1.jsx)(ui_1.Icon, { name: ui_1.Icons.Description, width: 24, height: 24 }) }));
}
const TooltipButton = (0, ui_1.withTooltip)(ui_1.ToolBarBaseButton);
exports.default = react_1.default.forwardRef(DescriptionButton);
